import styled from 'styled-components';

export default styled.div`

  /* font family: Roboto */
  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.ttf) format("truetype");
    font-weight: 100;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.ttf) format("truetype");
    font-weight: 300;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.ttf) format("truetype");
    font-weight: 400;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.ttf) format("truetype");
    font-weight: 700;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.woff) format("woff"), url(./fonts/Roboto/regular/Roboto-Regular.ttf) format("truetype");
    font-weight: 500;
    font-style: normal;
    /* Regular Expression */
  }

  /* font family: Roboto */
  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/thin/Roboto-Thin.ttf) format("truetype");
    font-weight: 100;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/light/Roboto-Light.ttf) format("truetype");
    font-weight: 300;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/medium/Roboto-Medium.ttf) format("truetype");
    font-weight: 400;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Roboto/bold/Roboto-Bold.ttf) format("truetype");
    font-weight: 700;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Roboto;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Roboto/regular/Roboto-Regular.woff) format("woff"), url(./fonts/Roboto/regular/Roboto-Regular.ttf) format("truetype");
    font-weight: 500;
    font-style: normal;
    /* Regular Expression */
  }

  .height_resizer {
      height: auto !important;
  }

  &.App {
    isolation: isolate;
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }
  .clearfix { display: inline-block; }
  * html .clearfix { height: 1%; }
  .clearfix { display: block; }

  .wgw-group-item.computers:before          { background-position: top    0px left    0px; }
  .wgw-group-item.phones:before             { background-position: top    0px left -100px; }
  .wgw-group-item.textiles:before           { background-position: top    0px left -200px; }
  .wgw-group-item.plastic_container:before  { background-position: top    0px left -300px; }
  .wgw-group-item.organics:before           { background-position: top    0px left -400px; }
  .wgw-group-item.christmas:before          { background-position: top    0px left -500px; }
  .wgw-group-item.hangers:before            { background-position: top    0px left -600px; }
  .wgw-group-item.furniture:before          { background-position: top    0px left -700px; }
  .wgw-group-item.glass:before              { background-position: top    0px left -800px; }

  .wgw-group-item.television:before         { background-position: top -100px left    0px; }
  .wgw-group-item.appliances:before         { background-position: top -100px left -100px; }
  .wgw-group-item.construction:before       { background-position: top -100px left -200px; }
  .wgw-group-item.yard_waste:before         { background-position: top -100px left -300px; }
  .wgw-group-item.cartons:before            { background-position: top -100px left -400px; }
  .wgw-group-item.oil_gas:before            { background-position: top -100px left -500px; }
  .wgw-group-item.take_out:before           { background-position: top -100px left -600px; }
  .wgw-group-item.pizza:before              { background-position: top -100px left -700px; }
  .wgw-group-item.covid-19:before              { background-position: top -100px left -800px; }

  .wgw-group-item.light_bulbs:before        { background-position: top -200px left    0px; }
  .wgw-group-item.batteries:before          { background-position: top -200px left -100px; }
  .wgw-group-item.shredded_paper:before     { background-position: top -200px left -200px; }
  .wgw-group-item.paint:before              { background-position: top -200px left -300px; }
  .wgw-group-item.plastic_bags:before       { background-position: top -200px left -400px; }
  .wgw-group-item.foil:before               { background-position: top -200px left -500px; }
  .wgw-group-item.aerosol_cans:before       { background-position: top -200px left -600px; }
  .wgw-group-item.styrofoam:before          { background-position: top -200px left -700px; }
  .wgw-group-item.polystyrene:before        { background-position: top -200px left -700px; }

/* Slider */
.slick-slider
{
    position: relative;

    display: block;
    height: 100% !important;
    box-sizing: border-box;

    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
        touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}

.slick-list
{
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
    height: 100% !important;
}
.slick-list:focus
{
    outline: none;
}
.slick-list.dragging
{
    cursor: pointer;
    cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list
{
    -webkit-transform: translate3d(0, 0, 0);
       -moz-transform: translate3d(0, 0, 0);
        -ms-transform: translate3d(0, 0, 0);
         -o-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
}

.slick-track
{
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
}
.slick-track:before,
.slick-track:after
{
    display: table;

    content: '';
}
.slick-track:after
{
    clear: both;
}
.slick-loading .slick-track
{
    visibility: hidden;
}

.slick-slide
{
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
}
[dir='rtl'] .slick-slide
{
    float: right;
}
.slick-slide img
{
    display: block;
}
.slick-slide.slick-loading img
{
    display: none;
}
.slick-slide.dragging img
{
    pointer-events: none;
}
.slick-initialized .slick-slide
{
    display: block;
}
.slick-loading .slick-slide
{
    visibility: hidden;
}
.slick-vertical .slick-slide
{
    display: block;

    height: auto;

    border: 1px solid transparent;
}
.slick-arrow.slick-hidden {
    display: none;
}

/* Slider */
.slick-loading .slick-list
{
    background: #fff url('./ajax-loader.gif') center center no-repeat;
}

/* Icons */
@font-face
{
    font-family: 'slick';
    font-weight: normal;
    font-style: normal;

    src: url('./fonts/slick.eot');
    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');
}
/* Arrows */
.slick-prev,
.slick-next
{
    font-size: 0;
    line-height: 0;

    position: absolute;
    top: 50%;

    display: none !important;

    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);

    cursor: pointer;

    color: transparent;
    border: none;
    outline: none;
    background: transparent;
}
.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus
{
    color: transparent;
    outline: none;
    background: transparent;
}
.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before
{
    opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before
{
    opacity: .25;
}

.slick-prev:before,
.slick-next:before
{
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;

    opacity: .75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-prev
{
    left: -25px;
}
[dir='rtl'] .slick-prev
{
    right: -25px;
    left: auto;
}
.slick-prev:before
{
    content: '←';
}
[dir='rtl'] .slick-prev:before
{
    content: '→';
}

.slick-next
{
    right: -25px;
}
[dir='rtl'] .slick-next
{
    right: auto;
    left: -25px;
}
.slick-next:before
{
    content: '→';
}
[dir='rtl'] .slick-next:before
{
    content: '←';
}

/* Dots */
.slick-dotted.slick-slider
{
    margin-bottom: 30px;
}

.slick-dots
{
    position: absolute;
    bottom: 0px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
}
.slick-dots li
{
    position: relative;

    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;

    cursor: pointer;
}
.slick-dots li button
{
    font-size: 0;
    line-height: 0;

    display: block;

    padding: 3px;
    border-radius: 6px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;

    border: 2px solid #ccc;
    background: transparent;
}
.slick-dots li button:hover {
    outline: none;
}
.slick-dots li button:focus
{
    /* outline: none; */
    box-shadow: 0px 0px 1px 2px #51a7e8;
    border-radius: 5px;
}
.slick-dots li button:hover:before,
.slick-dots li button:focus:before
{
    opacity: 1;
}
.slick-dots li button:before
{
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;

    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    content: '•';
    text-align: center;

    opacity: .25;
    color: transparent;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
li.slick-active > button
{
    color: transparent;
    background-color: #2A416B;
    padding: 5px;
    border: none;
}

.MuiTextField-root {
    position: absolute !important;
    z-index: 1 !important;
    height: 45px !important;
}

.MuiInputBase-inputAdornedEnd {
    max-width: 160px !important;
    width: 160px !important;
    padding: 10px !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border-radius: 7px !important;
    border: 1px solid #c3c3c3 !important;
    color: transparent !important;
    background-color: transparent !important;
    height: 45px !important;
}

.MuiInputBase-adornedEnd {
    position: relative !important;
    width: 160px !important;
    max-width: 160px !important;
    height: 45px !important
}

.MuiInputAdornment-positionEnd {
    position: absolute !important;
    top: 0 !important;
    width: 160px !important;
    max-width: 160px !important;
    height: 45px !important;
    border-radius: 7px !important;
}

.MuiInputAdornment-positionEnd > button {
    width: 100% !important;
    height: 45px !important;
    border: none !important;
    border-radius: 7px !important;
    background-color: transparent !important;
}

.MuiInputAdornment-positionEnd > button > span > svg {
    display: none !important;
}

`;
